module.exports = __webpack_public_path__ + "img/dialog-secondLicense.a41d183b.png";